import firebase from '../../../config/firebase';

const database = firebase.database();

// get all app users from database
export function getUsers(callback) {
  database.ref('users').on('value', function(snapshot) {
    const users = snapshot.val();
    callback(true, users, null);
  });
}

// delete an existing user
// cannot delete a user in Auth unless they have logged in recently
// can only delete in database
export function deleteUser (id, callback) {
  database.ref('users').child(id).remove((error) => {
    if (error) {
      callback(false, error);
    } else {
      callback(true, null);
    }
  })
}

// create a new user in Firebase and add them to the database
export function createNewUser (data, callback) {
  firebase.auth().createUserWithEmailAndPassword(data.email, 'GK1000')
    .then((user) => {
      var uid = null;
      if (user.uid) {
        uid = user.uid;
      }
      else {
        uid = user.user.uid;
      }
      if (!uid) {
        return;
      }
      data['id'] = uid;
      database.ref('users/' + uid).set(data, (error) => {
        if (error) {
          callback(false, null, error);
        } else {
          callback(true, data, null);
        }
      }
    )
  }).catch((error) => {callback(false, null, error); alert(error); });
}

// change a user's name, email, point total, birthday
// cannot edit Email in this function
// since firebase auth email would need to be updated as well
// and it requires a recent login
export function editUser (id, data, callback) {
  database.ref('users/' + id).update(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}

// remove a user's administrative privileges
export function removeFromAdmins(id, callback) {
  database.ref('users').child(id).child('admin').remove((error) => {
    if (error) {
      callback(false, error);
    } else {
      callback(true, null);
    }
  })
}

// change a user's administrative privileges
export function changeAdminRights(id, data, callback) {
  database.ref('users').child(id).child('admin').set(data, (error) => {
    if (error) {
      callback(false, error);
    } else {
      callback(true, null);
    }
  })
}
